export default __webpack_public_path__ + "static/media/tidesLeaders.1888c0ac.svg";